export const MdChatBubbleOutline = ({
  className = 'w-[24px] h-[24px]',
  ...props
}) => (
  <svg
    className={className}
    stroke='currentColor'
    fill='currentColor'
    strokeWidth='0'
    viewBox='0 0 24 24'
    height='24'
    width='24'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path fill='none' d='M0 0h24v24H0V0z'></path>
    <path d='M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H6l-2 2V4h16v12z'></path>
  </svg>
);

export const MdClose = ({ className = 'w-[24px] h-[24px]', ...props }) => (
  <svg
    className={className}
    stroke='currentColor'
    fill='currentColor'
    strokewidth='0'
    viewBox='0 0 24 24'
    height='24'
    width='24'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path fill='none' d='M0 0h24v24H0z'></path>
    <path d='M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z'></path>
  </svg>
);

export const MdOutlineArrowRightAlt = ({
  className = 'w-[24px] h-[24px]',
  ...props
}) => (
  <svg
    className={className}
    stroke='currentColor'
    fill='currentColor'
    strokeWidth='0'
    viewBox='0 0 24 24'
    height='24'
    width='24'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path fill='none' d='M0 0h24v24H0z'></path>
    <path d='M16.01 11H4v2h12.01v3L20 12l-3.99-4z'></path>
  </svg>
);

export const MdOutlineMenu = ({
  className = 'w-[24px] h-[24px]',
  ...props
}) => (
  <svg
    className={className}
    stroke='currentColor'
    fill='currentColor'
    strokeWidth='0'
    viewBox='0 0 24 24'
    height='24'
    width='24'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path fill='none' d='M0 0h24v24H0V0z'></path>
    <path d='M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z'></path>
  </svg>
);

export const MdOutlineSearch = ({
  className = 'w-[24px] h-[24px]',
  ...props
}) => (
  <svg
    className={className}
    stroke='currentColor'
    fill='currentColor'
    strokeWidth='0'
    viewBox='0 0 24 24'
    height='24'
    width='24'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path fill='none' d='M0 0h24v24H0V0z'></path>
    <path d='M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z'></path>
  </svg>
);

export const MdPersonOutline = ({
  className = 'w-[24px] h-[24px]',
  ...props
}) => (
  <svg
    className={className}
    stroke='currentColor'
    fill='currentColor'
    strokeWidth='0'
    viewBox='0 0 24 24'
    height='24'
    width='24'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path fill='none' d='M0 0h24v24H0V0z'></path>
    <path d='M12 5.9c1.16 0 2.1.94 2.1 2.1s-.94 2.1-2.1 2.1S9.9 9.16 9.9 8s.94-2.1 2.1-2.1m0 9c2.97 0 6.1 1.46 6.1 2.1v1.1H5.9V17c0-.64 3.13-2.1 6.1-2.1M12 4C9.79 4 8 5.79 8 8s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 9c-2.67 0-8 1.34-8 4v3h16v-3c0-2.66-5.33-4-8-4z'></path>
  </svg>
);

export const MdArrowDropDown = ({
  className = 'w-[24px] h-[24px]',
  ...props
}) => (
  <svg
    className={className}
    stroke='currentColor'
    fill='currentColor'
    strokeWidth='0'
    viewBox='0 0 24 24'
    height='24'
    width='24'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path fill='none' d='M0 0h24v24H0z'></path>
    <path d='m7 10 5 5 5-5z'></path>
  </svg>
);

export const MdLocationOn = ({ className = 'w-[24px] h-[24px]', ...props }) => (
  <svg
    className={className}
    stroke='currentColor'
    fill='currentColor'
    strokeWidth='0'
    viewBox='0 0 24 24'
    height='24'
    width='24'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path fill='none' d='M0 0h24v24H0z'></path>
    <path d='M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5a2.5 2.5 0 0 1 0-5 2.5 2.5 0 0 1 0 5z'></path>
  </svg>
);

export const MdLocationPin = ({
  className = 'w-[24px] h-[24px]',
  ...props
}) => (
  <svg
    className={className}
    stroke='currentColor'
    fill='currentColor'
    strokeWidth='0'
    viewBox='0 0 24 24'
    height='24'
    width='24'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path fill='none' d='M0 0h24v24H0z'></path>
    <path d='M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5a2.5 2.5 0 0 1 0-5 2.5 2.5 0 0 1 0 5z'></path>
  </svg>
);

export const MdOutlineCheck = ({
  className = 'w-[24px] h-[24px]',
  ...props
}) => (
  <svg
    className={className}
    stroke='currentColor'
    fill='currentColor'
    strokeWidth='0'
    viewBox='0 0 24 24'
    height='24'
    width='24'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path fill='none' d='M0 0h24v24H0z'></path>
    <path d='M9 16.17 4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z'></path>
  </svg>
);

export const AiFillCaretDown = ({
  className = 'w-[24px] h-[24px]',
  ...props
}) => (
  <svg
    className={className}
    stroke='currentColor'
    fill='currentColor'
    strokeWidth='0'
    viewBox='0 0 1024 1024'
    height='24'
    width='24'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path d='M840.4 300H183.6c-19.7 0-30.7 20.8-18.5 35l328.4 380.8c9.4 10.9 27.5 10.9 37 0L858.9 335c12.2-14.2 1.2-35-18.5-35z'></path>
  </svg>
);

export const MdNotificationsNone = ({
  className = 'w-[24px] h-[24px]',
  ...props
}) => (
  <svg
    className={className}
    stroke='currentColor'
    fill='currentColor'
    strokeWidth='0'
    viewBox='0 0 24 24'
    height='24'
    width='24'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path fill='none' d='M0 0h24v24H0z'></path>
    <path d='M12 22c1.1 0 2-.9 2-2h-4c0 1.1.9 2 2 2zm6-6v-5c0-3.07-1.63-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.64 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2zm-2 1H8v-6c0-2.48 1.51-4.5 4-4.5s4 2.02 4 4.5v6z'></path>
  </svg>
);

export const MdOutlineKeyboardArrowDown = ({
  className = 'w-[24px] h-[24px]',
  ...props
}) => (
  <svg
    className={className}
    stroke='currentColor'
    fill='currentColor'
    strokeWidth='0'
    viewBox='0 0 24 24'
    height='24'
    width='24'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path fill='none' d='M0 0h24v24H0V0z'></path>
    <path d='M7.41 8.59 12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z'></path>
  </svg>
);
